// Import required libraries using package manager
import React from "react";
import { render } from "react-dom";
import GroupContent from "./GroupContent.js";

class TopicGroup extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="topic-group">
        <div className="tg-bar" />

        <GroupContent
          tg_class={"tg-content"}
          content={this.props.content}
          theme={this.props.theme}
          size={this.props.size}
        />

        {/* <svg width={this.state.screenWidth} height={this.state.screenHeight}>
            <rect
            width={this.state.screenWidth}
            height={this.state.screenHeight}
            fill="var(--iah_red)"
            />
            </svg> */}
        {/* <ProjectCard
            image="/tmp-6.d8609974.jpg"
            size={{
            width: this.state.screenWidth,
            height: this.state.screenHeight
            }}
            /> */}
      </div>
    );
  }
}

export default TopicGroup;
